import { AddressResponseV3 } from 'api/models/address-response-v3'
import { AddressFormValues } from 'features/declaration/models/schemas/commonConsignmentSchemas'
import { Address } from './types'
import { AddressRequest, AddressResponse } from '../../../../api/models'

// eslint-disable-next-line import/prefer-default-export
export function fromAddressResponseV3(response: AddressResponseV3): Address {
  return {
    id: response.id,
    country: response.country,
  }
}

export function toCreateOrUpdateAddressRequest(
  address: AddressFormValues | null | undefined,
  transitOperationId: number,
): AddressRequest | null {
  if (!address) return null

  return {
    id: address?.id ?? null,
    addressLine: address?.addressLine ?? '',
    street: address?.street ?? '',
    streetNumber: address?.streetNumber ?? '',
    city: address?.city ?? '',
    country: address?.country ?? '',
    postcode: address.postcode ?? '',
    transitOperationId,
  }
}

export function parseAddressResponse(addressResponse?: AddressResponse | null): AddressFormValues {
  return {
    id: addressResponse?.id || null,
    addressLine: addressResponse?.addressLine ?? '',
    street: addressResponse?.street ?? '',
    streetNumber: addressResponse?.streetNumber ?? '',
    country: addressResponse?.country ?? '',
    city: addressResponse?.city ?? '',
    postcode: addressResponse?.postcode ?? '',
  }
}
